/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AzureSyncStatus {
    NO_AZURE_TEAM = 'no_azure_team',
    SYNCING = 'syncing',
    SYNCED = 'synced',
    FAILED = 'failed',
    MEMBERS_NOT_SYNCED = 'members_not_synced',
    ARCHIVED = 'archived',
}
